import React, {useState, useEffect} from "react";

import {Formik, Field, Form} from 'formik';
import * as Yup from 'yup';
import {i18n} from "translate/i18n";

import { createTagAction, editTagAction, Tags } from '../actions';

import {delTag, getTagId} from "../../../services/Tags.service";
import {useNavigate, useParams} from "react-router";
import {useUser} from "../../../store/providers/app";
import Page from "../../../components/Page";
import {swalQuestion} from "../../../components/Swal";
import {toast} from "react-toastify";
import {useQueryClient} from "react-query";

const FormTag = () => {

    const {id} = useParams()
    const navigate = useNavigate()
    const {user} = useUser();
    const {language} = useUser();

    const queryClient = useQueryClient()

    const [loading, setLoading] = useState(false)

    const INITIAL_FORM_VALUES = {
        language: language,
        name: '',
        name_en: '',
        description: '',
        tag_type_code: '',
    }

    const SignupSchema = Yup.object().shape({
        tag_type_code: Yup.string().required(i18n.t('inputError.tag')),
        name: Yup.string().required(i18n.t('inputError.title')),
    });

    const [formValues, setFormValues] = useState(INITIAL_FORM_VALUES);

    useEffect(() => {
        const Request = async () => {
            setLoading(true)
            const response = await getTagId(id);

            if (!response) {
                navigate('/tags')
            }

            setFormValues({
                name: response.name,
                name_en: response.name_en,
                description: response.description,
                tag_type_code: response.tag_type_code,
                language: response.language
            })

        }

        if (id) {
            Request().then(() => setLoading(false))
        }

    }, [id])

    function handleDelete(id) {

        swalQuestion(`<b>${i18n.t('questions.deleteTag')}</b>`).then(r => {
            if (r.isConfirmed) {
                delTag(id)
                    .then(() =>  {
                        toast.success(i18n.t('success.deletedTag'))
                        navigate('/tags')
                    })
                    .catch(() => toast.error(i18n.t('error.badRequest')))
            }
        })
    }

    return (
        <Page label={`${id ? 'Editar tag' : 'Criar tag'}`} icon="bi bi-tags" loading={loading}>
            <div className="mt-4">
                <Formik
                    initialValues={formValues}
                    validationSchema={SignupSchema}
                    enableReinitialize
                    onSubmit={async (values) => {
                        if (id) {
                            editTagAction(id, {...values, username: user.username})
                            queryClient.invalidateQueries(["listTags"])
                        } else {
                            createTagAction({...values, username: user.username})
                            queryClient.invalidateQueries(["listTags"])
                        }

                        navigate('/tags')
                    }}
                >
                    {({errors, touched}) => (
                        <Form>
                            <div className="card border-0 shadow-sm">
                                <div className="card-body">
                                    {/*<div className="form-group">*/}
                                    {/*    <label className="form-label">{i18n.t('label.language')}</label>*/}
                                    {/*    <Field as="select" className="form-select" name="language"*/}
                                    {/*           defaultValue={language}>*/}
                                    {/*        <option value="pt-BR">Português</option>*/}
                                    {/*        <option value="en-US">Inglês</option>*/}
                                    {/*    </Field>*/}
                                    {/*</div>*/}
                                    <div className="form-group">
                                        <label className="form-label">Tag</label>
                                        <Field as="select" className="form-select" name="tag_type_code">
                                            <option></option>
                                            {Tags.map(tag =>
                                                <option key={tag.value} value={tag.value}>{tag.label}</option>
                                            )}
                                        </Field>
                                        {errors.tag_type_code && touched.tag_type_code ? (
                                            <span className="text-danger text-sm">{errors.tag_type_code}</span>
                                        ) : null}
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">{i18n.t('label.title')} PT</label>
                                        <Field className="form-control" name="name"/>
                                        {errors.name && touched.name ? (
                                            <span className="text-danger text-sm">{errors.name}</span>
                                        ) : null}
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">{i18n.t('label.title')} EN</label>
                                        <Field className="form-control" name="name_en"/>
                                        {errors.name_en && touched.name_en ? (
                                            <span className="text-danger text-sm">{errors.name_en}</span>
                                        ) : null}
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">{i18n.t('label.description')}</label>
                                        <Field as="textarea" className="form-control" name="description"/>
                                    </div>
                                </div>
                                <div className="card-footer bg-white py-3 d-flex gap-2 flex-wrap justify-content-between">
                                    <button
                                        className="btn btn-secondary py-2 px-5 float-end"
                                        type="button"
                                        onClick={() => navigate('/tags')}
                                    > {i18n.t('buttons.return')}
                                    </button>

                                    <div className="d-flex flex-wrap  gap-2">
                                        { id &&
                                            <button
                                                className="btn btn-danger py-2 px-5 float-end"
                                                type="button"
                                                onClick={() => handleDelete(id)}
                                            > {i18n.t('buttons.delete')}
                                            </button>
                                        }
                                        <button
                                            className="btn btn-success py-2 px-5 float-end"
                                            type="submit"
                                        > {i18n.t('buttons.save')}
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </Page>
    )
}

export default FormTag
